import { registerPlugin, Capacitor } from '@capacitor/core';

// BiometricSecure bridge (iOS Face ID / Touch ID + Android BiometricPrompt).
//
// Purpose: provide a way to persist the Truva session token in the OS secure
// store, gated behind a live biometric prompt, so a returning user can unlock
// the app with Face ID / Touch ID / fingerprint instead of re-entering their
// password. The JS surface intentionally matches the two hand-rolled native
// plugins (BiometricSecurePlugin.swift / .java).
//
// Behavior notes for consumers:
//   - isAvailable(): resolves true only when biometric hardware + enrollment
//     exist on the device. Does NOT prompt.
//   - hasToken(): resolves true when a token is already stored (no prompt).
//   - saveToken({ token }): overwrite the stored token. On iOS this writes
//     into the Keychain (no prompt on write); on Android writing encrypts
//     under a Keystore key bound to user authentication.
//   - getToken(): TRIGGERS the biometric prompt. Resolves with the token when
//     the user authenticates; rejects with a user-facing error code when the
//     user cancels or authentication fails. resolve of auth = true when the
//     prompt began; auth=false when user cancelled / no-op.
//   - clearToken(): delete the stored token (no prompt). Called on logout.
//
// On non-native (desktop browser) this is a safe no-op so imports never throw.

let BiometricSecure;
if (Capacitor.isNativePlatform()) {
  BiometricSecure = registerPlugin('BiometricSecure');
} else {
  BiometricSecure = {
    isAvailable: async () => Promise.resolve({ available: false }),
    hasToken: async () => Promise.resolve({ has: false }),
    saveToken: async () => Promise.resolve(),
    getToken: async () => Promise.resolve({ token: null, auth: false }),
    clearToken: async () => Promise.resolve(),
  };
}

export default BiometricSecure;
